module.exports = __webpack_public_path__ + "static/img/join_5.d93a5bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_5.jpg
// module id = PrSD
// module chunks = 1